import { useState, useEffect } from 'react';
import { TextField, FormControl } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { debounce } from '@mui/material/utils';

const LazyAutocomplete = ({ field, language, handleChange, index, commonProps, handleOnBlur }) => {
    // Handle case where Options might be undefined or empty
    const fieldOptions = field.Options || [];
    
    const [options, setOptions] = useState(fieldOptions.slice(0, 200));
    const [inputValue, setInputValue] = useState('');
    const [selectedOption, setSelectedOption] = useState(() => {
        if (!field.Value || !fieldOptions.length) return null;
        return fieldOptions.find(opt => opt.OptionId === field.Value) || null;
    });

    const fetchOptions = debounce((searchTerm) => {
        if (!searchTerm) {
            setOptions(fieldOptions.slice(0, 200));
            return;
        }

        const filtered = fieldOptions.filter((opt) => {
            const description = (language === 'en' ? opt.DescriptionEn : opt.DescriptionEl) ?? '';
            return description.toLowerCase().includes((searchTerm ?? '').toLowerCase());
        });


        setOptions(filtered.slice(0, 200));
    }, 300);

    useEffect(() => {
        fetchOptions(inputValue);
    }, [inputValue]);

    useEffect(() => {
        if (!field.Value || !fieldOptions.length) {
            setSelectedOption(null);
            return;
        }
        const found = fieldOptions.find(opt => opt.OptionId === field.Value) || null;
        setSelectedOption(found);
    }, [field.Value, fieldOptions]);

    return (
        <FormControl fullWidth>
            <Autocomplete
                options={options}
                value={selectedOption}
                disabled={field.readonly === true || field.readonly === 'true'}
                getOptionLabel={(opt) => {
                    if (!opt) return '';
                    return (language === 'en' ? opt.DescriptionEn : opt.DescriptionEl) || '';
                }}
                onInputChange={(_, newInputValue) => setInputValue(newInputValue)}
                onChange={(_, newValue) => {
                    setSelectedOption(newValue || null);
                    if (handleChange) {
                        handleChange(index, newValue?.OptionId || null);
                    }
                }}
                onBlur={() => {
                    const optionId = selectedOption?.OptionId || null;
                    if (handleOnBlur) {
                        handleOnBlur(index, optionId);
                    }
                }}
                filterOptions={(x) => x}
                renderInput={(params) => (
                    <TextField
                        className='color-default'
                        {...params}
                        {...commonProps}
                        variant="outlined"
                        label={('')}
                    />
                )}
            />
        </FormControl>
    );
};

export default LazyAutocomplete;